import NewspaperIcon from "@mui/icons-material/Newspaper";
import { ClickAwayListener } from "@mui/material";
import { type FC } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";

import * as Styled from "./NewsMarkers.styles";
import { NewsMarkerTooltip } from "./NewsMarkerTooltip";
import { NewsMarkerTooltipSlider } from "./NewsMarkerTooltipSlider";
import { useNewsCursor } from "./useNewsCursor";
import { useNewsDots } from "./useNewsDots";
import { useNewsTooltip } from "./useNewsTooltip";

export const NewsMarkers: FC = () => {
  const { settings } = useCoreChart();
  const { dots, dotSize, isMobile } = useNewsDots();
  const { getTooltipProps, getBadgeProps, close } = useNewsTooltip(isMobile);
  const { onBadgeEnter, onBadgeLeave } = useNewsCursor();

  if (!settings.news || !dots.length) {
    return null;
  }

  return (
    <ClickAwayListener onClickAway={close}>
      <Styled.Root>
        {dots.map(({ key, leftPercent, sentiment }) => (
          <Styled.Line
            key={key}
            $leftPercent={leftPercent}
            $sentiment={sentiment}
          />
        ))}

        {dots.map(({ key, leftPercent, markers, sentiment }) => (
          <Styled.Dot key={key} $leftPercent={leftPercent}>
            <Styled.Tooltip
              title={
                markers.length > 1 ? (
                  <NewsMarkerTooltipSlider markers={markers} />
                ) : (
                  <NewsMarkerTooltip marker={markers[0]} />
                )
              }
              placement="top"
              disableFocusListener
              arrow
              slotProps={{
                tooltip: {
                  onMouseEnter: () => onBadgeEnter(markers[0]),
                  onMouseLeave: onBadgeLeave,
                },
              }}
              {...getTooltipProps(key)}
            >
              <Styled.Badge
                $sentiment={sentiment}
                $dotSize={dotSize}
                onMouseEnter={() => onBadgeEnter(markers[0])}
                onMouseLeave={onBadgeLeave}
                {...getBadgeProps(key)}
              >
                <NewspaperIcon />

                {markers.length > 1 && (
                  <Styled.Count>{markers.length}</Styled.Count>
                )}
              </Styled.Badge>
            </Styled.Tooltip>
          </Styled.Dot>
        ))}
      </Styled.Root>
    </ClickAwayListener>
  );
};
